import { render, staticRenderFns } from "./CardMemberLarge.vue?vue&type=template&id=36451050&scoped=true"
import script from "./CardMemberLarge.vue?vue&type=script&lang=js"
export * from "./CardMemberLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36451050",
  null
  
)

export default component.exports